import type { VrCaptureRequest } from '@indutrust/factory-model';

/** MSW-only row shape including a display label for follow-up merge. */
export type VrCaptureRequestMockRow = VrCaptureRequest & {
  factory_name: string;
};

/**
 * In-memory assisted-capture requests shared between factory MSW handlers
 * and the follow-up queue merge in demo / mocked e2e runs.
 */
export const vrCaptureRequestStore: VrCaptureRequestMockRow[] = [];

/** Clears the capture-request store (unit tests). */
export function resetVrCaptureRequestMockState(): void {
  vrCaptureRequestStore.length = 0;
}

/** Pending capture requests surfaced in the admin `no_vt` follow-up queue. */
export function pendingVrCaptureFollowUps(): VrCaptureRequestMockRow[] {
  return vrCaptureRequestStore.filter((row) => row.status === 'pending');
}
